import React 			from 'react';

// import {init} from './_Utils.js';

export default class PortalHeader extends React.Component {
	constructor(props) {
		super(props);
		
		this.state = {
		}
	}

	componentDidMount() {
		window.initBLPHeader();
	}

	render() {
		return (
			<div className="blp" id="js-blp-header"></div>
		);
	}





	// used in <Header/>

	showLogin(callback, mod) {
		this._loginCallback	= callback;
		this.toggleMenu("login", mod);
	}

	toggleMenu(menu, mod) {
		switch(menu) {
			case "login":
				if(document.getElementById('signupContainer')) {
					bl.login.closeSignupModal();
				}else{
					bl.login.showLoginModal(this._loginCallback, mod);
				}
				break;
			case "confirm_email":
				if(document.getElementById('signupContainer')) {
					bl.login.closeSignupModal();
				}else{
					bl.login.showSignupEmailModal();
				}
				break;
		}
	}

	onSessionUpdate = () => {
		this.setState({ dummy: this.state.dummy + 1 });
	}
}